import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Customer } from '../../../../models/customer';
import { ShowImageDialog } from '../../../../@shared/dialogs/show-image-dialog/show-image-dialog';
import { CommonModule, DatePipe } from '@angular/common';
import { CustomerService } from '../../../../services/customers/customer-service';
import { ActivatedRoute, ParamMap, RouterLink } from '@angular/router';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-customer-details-general-info-component',
  imports: [CommonModule, DatePipe, ShowImageDialog, RouterLink],
  templateUrl: './customer-details-general-info-component.html',
  styleUrl: './customer-details-general-info-component.scss'
})
export class CustomerDetailsGeneralInfoComponent implements OnInit {

  @Input() customerDetails: Customer | undefined;
  @Output() customerLoaded = new EventEmitter<Customer>();

  @Input() customerID: string | undefined
  showImageDialog = false

  private customerService = inject(CustomerService)
  private activatedRoute  = inject(ActivatedRoute)

  ngOnInit() {
    this.getCustomerDetails()
  }

  getCustomerDetails = () => {
    this.activatedRoute.paramMap.pipe(
      switchMap((params: ParamMap) => {
        this.customerID = params.get('id') as string
        return this.customerService.getCustomerById(this.customerID!)
      })
    ).subscribe({
      next: (res) => {
        this.customerDetails = res.data
        this.customerLoaded.emit(this.customerDetails);
      }
    })
  }

  openShowImageDialog = () => {
    this.showImageDialog = true
  }

  getStatusClass = (status?: string): string => {
    switch (status) {
      case 'ACTIVE':
        return 'text-green-500';
      case 'AWAITING_OTP_VERIFICATION':
        return 'text-yellow-500';
      case 'AWAITING_PAYMENT':
        return 'text-yellow-700';
      case 'PAYMENT_FAILED':
        return 'text-red-500';
      case 'AWAITING_DOCUMENT_UPLOAD':
        return 'text-orange-500';
      case 'AWAITING_DOCUMENT_REVIEW':
        return 'text-orange-600';
      case 'DOCUMENTS_REJECTED':
        return 'text-red-600';
      case 'BANNED':
        return 'text-red-700';
      default:
        return '';
    }
  }

}
